// extracted by mini-css-extract-plugin
module.exports = {"tableFavoriteButton":"TableFavoriteButton_tableFavoriteButton__191GE","notFavorited":"TableFavoriteButton_notFavorited__3qFN9","icon":"TableFavoriteButton_icon__2xh2h"};